import { z } from 'zod';

export const TransitInvalidateSchema = z.object({
  transitId: z.string().min(1, { message: 'Required' }),
  reason: z.string().min(1, { message: 'Required' }),
});
export type TransitInvalidateData = z.infer<typeof TransitInvalidateSchema>;
